/**
 * Predictive search for mobile menu search bars.
 * Handles all [data-menu-predictive-search] forms generically.
 */
(function () {
  var DEBOUNCE_MS = 300;

  function localDebounce(fn, delay) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, delay);
    };
  }

  var debounceFn = typeof debounce === 'function' ? debounce : localDebounce;

  function showLoading(container) {
    container.setAttribute('aria-busy', 'true');
    container.classList.add('menu-predictive-search--loading');
    container.innerHTML =
      '<div class="menu-predictive-search__loading" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66" width="20" height="20" class="spinner">' +
      '<circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>' +
      '</svg></div>';
    container.style.display = 'block';
  }

  function showResults(container, html) {
    container.removeAttribute('aria-busy');
    container.classList.remove('menu-predictive-search--loading');
    container.innerHTML = html;
    container.style.display = 'block';
  }

  function showNoResults(container, query) {
    container.removeAttribute('aria-busy');
    container.classList.remove('menu-predictive-search--loading');
    container.innerHTML =
      '<div class="menu-predictive-search__empty">No results for &ldquo;' +
      query.replace(/</g, '&lt;') +
      '&rdquo;.</div>';
    container.style.display = 'block';
  }

  function showError(container) {
    container.removeAttribute('aria-busy');
    container.classList.remove('menu-predictive-search--loading');
    container.innerHTML =
      '<div class="menu-predictive-search__empty" role="alert">Something went wrong. Try again.</div>';
    container.style.display = 'block';
  }

  function hideResults(container) {
    container.style.display = 'none';
    container.innerHTML = '';
    container.removeAttribute('aria-busy');
    container.classList.remove('menu-predictive-search--loading');
  }

  function initForm(form) {
    var input = form.querySelector('input[type="search"]');
    var container = form.querySelector('[data-menu-predictive-search-results]');
    if (!input || !container) return;

    var controller = null;

    function performSearch(query) {
      if (typeof routes === 'undefined' || !routes.predictive_search_url) return;

      if (controller) {
        controller.abort();
      }
      controller = new AbortController();

      var tagExclusionSuffix = ' NOT tag:nosearch NOT tag:no_rebuy_upsell NOT tag:free-gift NOT tag:exclude';
      var url =
        routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(query + tagExclusionSuffix) +
        '&section_id=predictive-search';

      showLoading(container);

      fetch(url, { signal: controller.signal })
        .then(function (resp) {
          if (!resp.ok) throw new Error('Search failed');
          return resp.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          var html = section ? section.innerHTML : '';
          if (!html || !html.trim()) {
            showNoResults(container, query);
          } else {
            showResults(container, html);
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          showError(container);
        });
    }

    var debouncedSearch = debounceFn(function () {
      var query = input.value.trim();
      if (!query) {
        hideResults(container);
        return;
      }
      performSearch(query);
    }, DEBOUNCE_MS);

    input.addEventListener('input', debouncedSearch);

    // Re-show cached results when re-focusing with a value
    input.addEventListener('focus', function () {
      if (input.value.trim() && container.innerHTML.trim()) {
        container.style.display = 'block';
      }
    });

    // Dismiss results on outside click
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) {
        hideResults(container);
      }
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-menu-predictive-search]');
    for (var i = 0; i < forms.length; i++) {
      initForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
